import { Component, Input, OnInit } from '@angular/core';
import { FormBuilderBasicInputModel } from '../../models/form-builder-basic-input-model';
import { FormBuilderSectionModel } from '../../models/form-builder-section-model';

@Component({
  selector: 'tf-core-fb-editor-component-section',
  templateUrl: './fb-editor-component-section.component.html',
  styleUrls: ['./fb-editor-component-section.component.css']
})
export class FbCoreEditorComponentSectionComponent implements OnInit {
    @Input()
    section: FormBuilderSectionModel;

    // Type can be any of the following: default, preview, published
    @Input()
    type: string;

    @Input()
    canBeDragged: boolean;

    public status: string;

    constructor(
    ) { }

    ngOnInit(): void {
        if (this.type === undefined) {
            this.type = 'default';
        }

        if (this.status === undefined) {
            this.status = '';
        }

        if (this.section.active) {
            this.section.active = false;

            this.setStatus(!(this.type !== 'default'));
        }

    }

    private setStatus(status: boolean): void {
        if (status === true) {
            if (this.section.active === status) {
                return;
            }
            
            this.section.setAsActive(true);
            this.status = 'active';
            
            return;
        }
        
        this.section.setAsActive(false);
        this.status = '';
    }

    public handleClick(event: MouseEvent): void {
        event.stopPropagation();

        if (this.type !== 'default') {
            return;
        }

        this.setStatus(true);

    }


    public handleDefaultDuplicate(): FormBuilderSectionModel {
        const componentData = this.section.components[0];

        const section = new FormBuilderSectionModel(`${this.section.label}-copy`);

        section.setAsActive(true);

        const component = new FormBuilderBasicInputModel();

        component.mountWithDefaults({ label: componentData.label, type: componentData.type });

        component.duplicateComponent(componentData);

        section.addComponent(component);

        return section;
    }

    public handlePrebuildDuplicate(): FormBuilderSectionModel {
        const section = new FormBuilderSectionModel(`${this.section.label}-copy`);

        section.setAsActive(true);

        section.setTitle(this.section.title);

        section.setType(this.section.type);

        this.section.components.map((component: FormBuilderBasicInputModel) => {
            let newComponent = new FormBuilderBasicInputModel();

            newComponent.mountWithValues(component);

            section.addComponent(newComponent);
        });

        return section;
    }

    public getType(): string {
        if (this.section.type !== 'default') {
            return this.section.type;
        }

        return this.section.getComponentType(0);
    }

    public getClasses(): any {
        return [
            this.getType(),
            this.type,
            this.status
        ];
    }

    public getTitle(): string {
        switch (this.getType()) {
            case 'prebuild':
                return 'Pre-build component';
            case 'p':
                return 'Paragraph input';
            case 'text_input':
                return 'Text input';
            case 'email_input':
                return 'Email input';
            case 'number_input':
                return 'Number input';
            case 'date_input':
                return 'Date input';
            case 'date_from_and_to':
                return 'Date range input';
            case 'rate_input':
                return 'Rate input';
            case 'single_select':
                return 'Single select';
            case 'multi_select':
                return 'Multi select';
            case 'checklist':
                return 'Checklist';
            case 'section':
                return 'Section';
        }
        
    }
}
